import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '@hig/modal';
import IconButton from '@hig/icon-button';
import { Sync16, Down16, Up16 } from '@hig/icons';
import Dropdown from '@hig/dropdown';
import { RiCheckLine, RiCloseLine } from 'react-icons/ri';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import ace from 'brace';
import 'brace/mode/json';
import 'brace/theme/github';
import { ForgeEnvironmentEnum } from '../../data/api/utils';

export class SchemaValidationViewer extends Component {
  state = {
    currentSelection: 0,
    currentEnvironmentId: ForgeEnvironmentEnum.STAGING,
  };
  environments = [
    {
      item: ForgeEnvironmentEnum.STAGING,
      value: 0,
    },
    {
      item: ForgeEnvironmentEnum.PRODUCTION,
      value: 1,
    },
  ];
  setEditorRef1 = (instance) => (this.editor1 = instance);
  setEditorRef2 = (instance) => (this.editor2 = instance);

  _handleEnvironmentChange = (envId) => {
    this.setState({ ...this.state, currentEnvironmentId: envId });
    if (envId === ForgeEnvironmentEnum.STAGING) {
      this.editor2.jsonEditor.set(this.props.targetJsonStaging);
    } else {
      this.editor2.jsonEditor.set(this.props.targetJsonProduction);
    }
  };

  _handleChangeMode = () => {
    const mode1 = this.editor1.jsonEditor.getMode();
    const mode2 = this.editor2.jsonEditor.getMode();
    // console.log(mode1);
    if (mode1 === 'tree' && mode2 === 'tree') {
      this.editor1.jsonEditor.setMode('code');
      this.editor2.jsonEditor.setMode('code');
    } else if (mode1 === 'code' && mode2 === 'code') {
      this.editor1.jsonEditor.setMode('tree');
      this.editor2.jsonEditor.setMode('tree');
      this.editor1.jsonEditor.expandAll();
      this.editor2.jsonEditor.expandAll();
    }
  };

  _handleNextDiff = () => {
    if (this.editor1 !== undefined && this.editor2 !== undefined) {
      const edit1Lines = this.editor1.jsonEditor.getText().split('\n');
      const edit2Lines = this.editor2.jsonEditor.getText().split('\n');
      const maxLineCount = Math.max(edit1Lines.length, edit2Lines.length);
      for (let i = 0; i < maxLineCount; i++) {
        const editor1Line = i < edit1Lines.length - 1 ? edit1Lines[i] : undefined;
        const editor2Line = i < edit2Lines.length - 1 ? edit2Lines[i] : undefined;
        if (editor1Line !== editor2Line && i > this.state.currentSelection) {
          if (editor1Line !== undefined) {
            this.editor1.jsonEditor.setTextSelection(
              { row: i + 1, column: 0 },
              { row: i + 1, column: editor1Line.length + 1 }
            );
          }
          if (editor2Line !== undefined) {
            this.editor2.jsonEditor.setTextSelection(
              { row: i + 1, column: 0 },
              { row: i + 1, column: editor2Line.length + 1 }
            );
          }
          this.setState({
            currentSelection: i,
          });
          break;
        }
      }
    }
  };

  _handlePreDiff = () => {};

  componentDidMount() {
    if (this.editor1 !== undefined && this.editor2 !== undefined) {
      this.editor1.jsonEditor.setMode('code');
      this.editor2.jsonEditor.setMode('code');
    }
  }

  render() {
    const {
      open,
      sourceJson,
      targetJsonStaging,
      targetJsonProduction,
      jsonDifferentStaging,
      jsonDifferentProduction,
    } = this.props;

    const diffs = new Map();
    diffs.set(ForgeEnvironmentEnum.STAGING, jsonDifferentStaging);
    diffs.set(ForgeEnvironmentEnum.PRODUCTION, jsonDifferentProduction);
    const targets = new Map();
    targets.set(ForgeEnvironmentEnum.STAGING, targetJsonStaging);
    targets.set(ForgeEnvironmentEnum.PRODUCTION, targetJsonProduction);
    const results = [ForgeEnvironmentEnum.STAGING, ForgeEnvironmentEnum.PRODUCTION].map((env) => {
      const envString = env[0].toUpperCase() + env.substring(1);
      const targetJson = targets.get(env);
      const diff = diffs.get(env);
      let result = (
        <h4 className="info">
          {envString} Result: <RiCheckLine /> FSS schema is identical with Raw Schema in GitHub.
        </h4>
      );
      if (targetJson === undefined || Object.entries(targetJson).length === 0) {
        result = (
          <h4 className="error">
            {envString} Result: <RiCloseLine /> This schema is NOT published to FSS.
          </h4>
        );
      } else if (diff) {
        result = (
          <h4 className="error">
            {envString} Result: <RiCloseLine /> FSS schema is NOT identical with Raw Schema in
            GitHub.
          </h4>
        );
      }
      return result;
    });
    return (
      <Modal
        className="schemaviewer"
        title={'Schema Validation viewer'}
        open={open}
        onCloseClick={() => {
          this.props.onExited();
        }}
      >
        {results}
        <div className="toolbar">
          <IconButton
            icon={<Sync16 />}
            on={false}
            onClick={this._handleChangeMode}
            title={''}
            className="App__refresh"
          />
          {jsonDifferentStaging && (
            <IconButton
              icon={<Down16 />}
              on={false}
              onClick={this._handleNextDiff}
              title={''}
              className="App__refresh"
            />
          )}
          {jsonDifferentStaging && (
            <IconButton
              icon={<Up16 />}
              on={false}
              onClick={this._handlePreDiff}
              title={''}
              className="App__refresh"
            />
          )}
        </div>
        <div className="flex-container">
          <div className="flex-child">
            <h4>Repository Json File</h4>
            <Editor ref={this.setEditorRef1} ace={ace} value={sourceJson} />
          </div>
          <div className="flex-child">
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <h4>FSS Schema Json - </h4>
              <form
                id="a_form"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '200px',
                  marginTop: '-15px',
                  marginLeft: '10px',
                }}
              >
                <Dropdown
                  placeholder=""
                  options={this.environments}
                  value={this.state.currentEnvironmentId}
                  onChange={this._handleEnvironmentChange}
                />
              </form>
            </div>
            <Editor ref={this.setEditorRef2} ace={ace} value={targetJsonStaging} />
          </div>
        </div>
      </Modal>
    );
  }
}

SchemaValidationViewer.propTypes = {
  open: PropTypes.func,
  sourceJson: PropTypes.any,
  targetJsonStaging: PropTypes.any,
  targetJsonProduction: PropTypes.any,
  jsonDifferentStaging: PropTypes.any,
  jsonDifferentProduction: PropTypes.any,
  onExited: PropTypes.func,
};

export default SchemaValidationViewer;
